export default __webpack_public_path__ + "static/media/202102【For 復國幼兒園家長】操作手冊.0c2f7095.pdf";